<template>
  <div class="share-network">
  <ShareNetwork
    v-for="network in networks"
    :network="network.network"
    :key="network.network"
    :style="{backgroundColor: network.color}"
    :url="sharingUrl"
    :title="sharing.title"
    :description="sharing.description"
    :quote="sharing.quote"
    :hashtags="sharing.hashtags"
    :twitterUser="sharing.twitterUser"
  >
    <i :class="network.icon"></i>
    <span>{{ network.name }}</span>
  </ShareNetwork>
  </div>
</template>

<script>
  
export default {
  props: ['sharingUrl','sharingDesc'],
  data () {
    return {
      sharing: {
        //url: sharingUrl,
        title: "köhler. Klinker App. Ideen sammeln für das nächste Klinker Projekt!\n",
        description: "\nDie köhler Klinker App ist die zentrale App für die Auswahl von Steinen für Ihr nächstes Klinkerprojekt. Klinker und Riemchen auswählen, in Projekten organisieren und mit anderen teilen, Muster und Angebote anfragen und Texturen laden. köhler. Ideen in Stein.",
        //quote: 'The hot reload is so fast it\'s near instant. - Evan You',
        hashtags: 'klinkerapp,köhler,koehler,riemchen,verblender,klinker,fassade',
        //twitterUser: 'youyuxi'
      },
      networks: [
        { network: 'email', name: 'Email', icon: 'social-icon social-icon-envelope', color: '#333333' },
        { network: 'whatsapp', name: 'Whatsapp', icon: 'social-icon social-icon-whatsapp', color: '#25d366' },
        { network: 'telegram', name: 'Telegram', icon: 'social-icon social-icon-telegram', color: '#0088cc' },
        { network: 'facebook', name: 'Facebook', icon: 'social-icon social-icon-facebook', color: '#1877f2' },
        { network: 'twitter', name: 'Twitter', icon: 'social-icon social-icon-twitter', color: '#1da1f2' },
        { network: 'linkedin', name: 'LinkedIn', icon: 'social-icon social-icon-linkedin', color: '#007bb5' },
        { network: 'xing', name: 'Xing', icon: 'social-icon social-icon-xing', color: '#026466' },
        { network: 'pinterest', name: 'Pinterest', icon: 'social-icon social-icon-pinterest', color: '#bd081c' },
      ]
    }
  },
  created: function(){
    if(sharingDesc != "")
    this.description = sharingDesc 
  },
}
</script>
<style scoped>
  svg {
    fill: #ffffff;
  }
  .share-network { display: flex; flex-wrap: wrap; justify-content: center; }
  .share-network a { display: inline-block; width: 46%; margin: 2%; white-space: nowrap; display: flex; align-items: center; }
  .share-network a i { display: inline-block; height: 2.7333rem; width: 2.7333rem; background-size: 1.5rem; background-position: center center; background-repeat: no-repeat; background-color: rgba(0,0,0,0.15); transition: background-color 0.3s; }
  .share-network a span { display: inline-block; padding: 0.33333em 0.73333em; }
  .social-icon-envelope { background-image: url(/img/icons-white/envelope.svg); }
  .social-icon-whatsapp { background-image: url(/img/social-icons/whatsapp.svg); }
  .social-icon-telegram { background-image: url(/img/social-icons/telegram.svg); }
  .social-icon-facebook { background-image: url(/img/social-icons/facebook.svg); }
  .social-icon-twitter { background-image: url(/img/social-icons/twitter.svg); }
  .social-icon-linkedin { background-image: url(/img/social-icons/linkedin.svg); }
  .social-icon-xing { background-image: url(/img/social-icons/xing.svg); }
  .social-icon-pinterest { background-image: url(/img/social-icons/pinterest.svg); }
 
  .share-network a:hover i { background-color: rgba(0,0,0,0.3); }  
</style>


